export { CmsEntryOpenSearchBodyModifier } from "./abstractions.js";
